import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  ComponentRef,
  EmbeddedViewRef,
  Inject
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AppendComponentService {
  private window: Window;

  constructor(
    @Inject(DOCUMENT) private document,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {
    this.window = (this.document as Document).defaultView;
  }

  appendComponent(component: any, element?: HTMLElement): ComponentRef<any> {
    const componentRef: ComponentRef<any> = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(this.injector);

    this.appRef.attachView(componentRef.hostView);

    const compElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    element = element || this.document.body;

    element.appendChild(compElem);

    this.window.setTimeout(() => this.appRef.tick(), 0);

    return componentRef;
  }

  removeComponent(component: ComponentRef<any>) {
    this.appRef.detachView(component.hostView);
    component.destroy();
  }
}
